const env = process.env.NODE_ENV;
// 后端服务地址
export const apiPath = `${
  env === "development" || !window.server || !window.server.API_URL
    ? process.env.VUE_APP_API_URL
    : window.server.API_URL
}`;
// 图片服务地址
export const imgApiPath = `${
  env === "development" || !window.server || !window.server.IMG_URL
    ? process.env.VUE_APP_IMG_URL
    : window.server.IMG_URL
}`;
